import { Express } from "express";

import { SingletonController } from "../../Commons/HttpServer/ExpressWrapper/SingletonController";
import { FarmDirectory } from "../BuildServer/ResourcesControllers/Directories/FarmDirectory";
import { FarmConfig } from "../../CandyCLI";
import { httpGet } from "../../Commons/HttpServer/AttributeRouting/Methods";
import { httpReturn } from "../../Commons/HttpServer/AttributeRouting/Results";
import { httpType, httpUrlParam } from "../../Commons/HttpServer/AttributeRouting/Params";
import { reject } from "../../../../Common/TypingUtils";

import { resolveFormPath, getLegacyGenerator } from "./Utils";

export class ExtractTextsFromSugarController extends SingletonController {
    private allFarmDirectories: FarmDirectory[];
    private readonly allFarmConfig: FarmConfig[];

    public constructor(allFarmConfig: FarmConfig[]) {
        super();
        this.allFarmConfig = allFarmConfig;
        this.allFarmDirectories = allFarmConfig.map(i => new FarmDirectory(i.farmDirectory));
    }

    public async setupMiddleware(expressApplication: Express) {
        expressApplication.use("/force-gfvs", (_, __, next) => {
            this.resetAllFarmDirectories();
            next();
        });
    }

    private resetAllFarmDirectories() {
        this.allFarmDirectories = this.allFarmConfig.map(i => new FarmDirectory(i.farmDirectory));
    }

    @httpGet("/extract-sugar-text/:gfv", httpReturn.Json, httpUrlParam("gfv", httpType.String))
    public async getTextsFromSugar(gfv: string) {
        const farmConfig = this.allFarmConfig[0] ?? reject(`Cannot find farm config for: ${gfv}`);
        const farmDirectory = this.allFarmDirectories[0] ?? reject(`Cannot find FarmDirectory for: ${gfv}`);
        const formPath = await resolveFormPath(gfv, farmDirectory);
        const generator = await getLegacyGenerator();
        return await generator.getSugarTexts(formPath, farmConfig.farmDirectory);
    }
}
